module.exports = __webpack_public_path__ + "img/about7.55d93f5f.png";